import { render, staticRenderFns } from "./multi_user_select.vue?vue&type=template&id=35999e4c&"
import script from "./multi_user_select.vue?vue&type=script&lang=js&"
export * from "./multi_user_select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports